/**
 * CategoriaChecklist - Componente de categoria expansível do checklist
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { ChevronDown, ChevronRight } from 'lucide-react';
import ItemChecklist from './ItemChecklist';

const CategoriaChecklist = ({
  categoria,
  itensCategoria,
  checklistItems,
  isExpanded,
  onToggle,
  fornecedores,
  podeVerCustos,
  onUpdateItem,
  onRemoveItem,
  onDragStartItem,
  onDragOverItem,
  onDragLeaveItem,
  onDropItem,
  dragOverIndex,
  onOpenAddProduto,
  onUpdateItemCusto,
  onRemoveItemCusto,
  onFornecedoresUpdate,
  projeto,
  embarcacaoIndex,
  onOpenSolicitarCompra
}) => {
  const safeItens = Array.isArray(itensCategoria) ? itensCategoria : [];
  const safeAll = Array.isArray(checklistItems) ? checklistItems : [];
  const completosCategoria = safeItens.filter(i => i?.status).length;
  const progressoCategoria = safeItens.length > 0 
    ? (completosCategoria / safeItens.length) * 100 
    : 0;

  return (
    <div className="border rounded-lg overflow-hidden" data-testid={`categoria-${categoria}`}>
      <button
        onClick={() => onToggle(categoria)}
        className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
      >
        <div className="flex items-center gap-3">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
          <span className="font-medium">{categoria}</span>
          <Badge variant="outline" className="text-xs">
            {completosCategoria}/{safeItens.length}
          </Badge>
        </div>
        <div className="w-24">
          <Progress value={progressoCategoria} className="h-2" />
        </div>
      </button>
      
      {isExpanded && (
        <div className="divide-y">
          {safeItens.map((item) => {
            const realIndex = safeAll.findIndex(i => i === item);
            return (
              <ItemChecklist
                key={realIndex}
                item={item}
                index={realIndex}
                fornecedores={fornecedores}
                podeVerCustos={podeVerCustos}
                onUpdateItem={onUpdateItem}
                onRemoveItem={onRemoveItem}
                onDragStartItem={onDragStartItem}
                onDragOverItem={onDragOverItem}
                onDragLeaveItem={onDragLeaveItem}
                onDropItem={onDropItem}
                dragOverIndex={dragOverIndex}
                onOpenAddProduto={onOpenAddProduto}
                onUpdateItemCusto={onUpdateItemCusto}
                onRemoveItemCusto={onRemoveItemCusto}
                onFornecedoresUpdate={onFornecedoresUpdate}
                projeto={projeto}
                embarcacaoIndex={embarcacaoIndex}
                onOpenSolicitarCompra={onOpenSolicitarCompra}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CategoriaChecklist;
